import React from "react"
import { cardClass, sectionPad } from "../../config/theme"

type Props = {
  children: React.ReactNode
  className?: string
  noPadding?: boolean
  title?: string
  icon?: string
}

export default function SectionCard({ children, className = "", noPadding = false, title, icon }: Props) {
  const paddingClass = noPadding ? "" : sectionPad
  return (
    <div className={`${cardClass} ${paddingClass} ${className}`}>
      {title && icon && (
        <div className="flex items-center mb-4">
          <span className="text-2xl mr-3">{icon}</span>
          <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        </div>
      )}
      {children}
    </div>
  )
}
